module.exports = __webpack_public_path__ + "media/packs/site/assets/images/photobook/order_thumbnail-1dca0ecb3ba2e4ece2e76a38acaf1935.png";